import './HomePage.css'

import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useParams } from 'react-router-dom'

import JoinDiscussionOverlay from '../components/JoinDiscussionOverlay'
import { useLogger } from '../logger'
import { useEventTracker } from '../providers/event-tracker-provider'

export default function InvitePage() {
  const { code } = useParams<{ code: string }>()
  const logger = useLogger()
  const { tracker: eventTracker } = useEventTracker()

  useEffect(() => {
    logger.info('Invite page loaded', { code })
    if (typeof code === 'string') {
      eventTracker.track({ name: 'Invite Page Viewed', code })
    } else {
      eventTracker.track({ name: 'Invite Page Viewed' })
    }
  }, [code, logger, eventTracker])

  // Parse the code to extract forumName and optional commentId
  const parseCode = (encodedCode: string | undefined) => {
    if (!encodedCode) {
      return { forumName: '', commentId: undefined }
    }

    try {
      const decodedCode = decodeURIComponent(encodedCode)

      // Check if code contains commentId
      // Format: "forumName?commentId=xxx"
      const [forumName, queryString] = decodedCode.split('?')

      if (queryString) {
        const params = new URLSearchParams(queryString)
        const commentId = params.get('commentId')
        return { forumName, commentId: commentId || undefined }
      }

      return { forumName: decodedCode, commentId: undefined }
    } catch (error) {
      logger.error('Error parsing invite code', { error, code: encodedCode })
      return { forumName: encodedCode || '', commentId: undefined }
    }
  }

  const { forumName, commentId } = parseCode(code)

  if (!forumName) {
    return (
      <div className="home-container">
        <Helmet>
          <title>Nugle - Join the Discussion</title>
        </Helmet>
        <img src="/nugle-clear.png" alt="Nugle Logo" className="logo" />
        <p>reason meets reality</p>
        <p style={{ marginTop: '20px', color: '#666' }}>Invalid invite code</p>
      </div>
    )
  }

  return (
    <div className="home-container">
      <Helmet>
        <title>Join {forumName} on Nugle</title>
        <meta name="description" content={`You've been invited to join the discussion on Nugle`} />
      </Helmet>
      <img src="/nugle-clear.png" alt="Nugle Logo" className="logo" />
      <JoinDiscussionOverlay
        forumName={forumName}
        commentId={commentId}
        onClose={() => {
          // Navigate home or do nothing on close
          window.history.pushState({}, '', '/')
        }}
      />
    </div>
  )
}
